import React from 'react';
import styled from 'styled-components';
import Button from '@ingka/button';
import QuantityDropdown from '@ingka/quantity-dropdown';
import useTranslation from '../hooks/useTranslation';
import { SparePartCount } from '../interfaces/Item';
import { Item } from './Item';
import { useCartItemQuantityController } from '../hooks/useOrder';

/* globals CSS_CONFIG */

const StyledRemoveButton = styled(Button)`
  span {
    text-decoration: underline;
  }
`;

const RemoveQuantityDropdown = styled(QuantityDropdown)`
  ${`@media (min-width: 375px) {
    margin-inline-end: 20px;
  }`}
`;
export const CartItemDisplay: React.FC<SparePartCount> = ({
  item,
  quantity,
}): JSX.Element => {
  const [{ loading }, { removeFromCart, changeQuantity }] =
    useCartItemQuantityController(item, quantity);
  const { t } = useTranslation();
  const maxNumberToSelect = Math.min(
    Math.min(item.stock, CSS_CONFIG.ITEM_LIMIT),
    CSS_CONFIG.ITEM_LIMIT
  );

  return (
    <Item item={item} showImageDot={true} enableOptions={true}>
      <div style={{ display: 'flex' }}>
        <div style={{ flex: 'inherit' }}>
          <RemoveQuantityDropdown
            value={quantity}
            max={maxNumberToSelect}
            onChange={changeQuantity}
            ariaLabel={t('spareParts.ariaLabel.changeQuantity')}
          />
        </div>
        <div style={{ flex: 'inherit' }}>
          <StyledRemoveButton
            type="tertiary"
            small
            iconOnly
            loading={loading}
            onClick={removeFromCart}
            text={t('spareParts.remove')}
            aria-label={t('spareParts.ariaLabel.removeFromCart')}
          />
        </div>
      </div>
    </Item>
  );
};
